import React, { useState, useEffect, useRef } from 'react';
import {
  CRow,
  CCol,
  CInput,
  CFormText,
  CSelect,
  CModal,
  CForm,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CButton,
  CInputFile,
  CTextarea,
} from '@coreui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CSpinner } from '@coreui/react';
import LoaderButton from '../components/LoaderButton';
import ImageUploadService from '../services/image-upload.service';

const BrandForm = ({
  AddBrand,
  isloading,
  showModal,
  onModalClose,
  categories,
  updateItem,
  UpdateBrand,
}) => {
  const [previewImage, setPreviewImage] = useState();
  const [previewSocialImage, setPreviewSocialImage] = useState();

  const fileInput = useRef();

  const validationSchema = Yup.object().shape({
    logo: Yup.mixed().required('Logo is required'),
    name: Yup.string().required('Name is required'),
    categories: Yup.array().required('Please select atleast 1 category'),
    description: Yup.string(),
    buyLink: Yup.string().url('buy link shuould be a url'),
    socialImage: Yup.mixed().required('Social image is required'),
  });

  // initialize form with formik
  const { handleChange, handleSubmit, values, errors, touched, setFieldValue } =
    useFormik({
      initialValues: {
        logo: updateItem.logo ? updateItem.logo : null,
        name: updateItem.name ? updateItem.name : '',
        categories:
          updateItem.categories.length !== 0
            ? updateItem.categories.map((item) => item._id)
            : [],
        description: updateItem.description || '',
        buyLink: updateItem.buyLink || '',
        socialImage: updateItem.socialImage ? updateItem.socialImage : null,
      },
      validationSchema,
      enableReinitialize: true,
      onSubmit: async (brand, { resetForm }) => {
        if (updateItem._id) {
          await UpdateBrand(brand);
        } else {
          await AddBrand(brand);
        }

        resetForm({ values: '' });
        setPreviewImage(null);
        fileInput.current.value = '';
      },
    });

  useEffect(() => {});

  useEffect(() => {
    if (updateItem.logo) {
      setPreviewImage(updateItem.logo);
    } else setPreviewImage(null);
  }, [updateItem.logo]);

  useEffect(() => {
    if (updateItem.socialImage) {
      setPreviewSocialImage(updateItem.socialImage);
    } else setPreviewSocialImage(null);
  }, [updateItem.socialImage]);

  const handleLogoSelection = async (e) => {
    try {
      const base64 = await ImageUploadService.toBase64(e.target.files[0]);
      const { data } = await ImageUploadService.upload(base64);
      setPreviewImage(data.secure_url);
      setFieldValue('logo', data.secure_url);
    } catch (e) {
      console.log('error', e);
    }
  };

  const handleSocialImageSelection = async (e) => {
    try {
      const base64 = await ImageUploadService.toBase64(e.target.files[0]);
      const { data } = await ImageUploadService.upload(base64);
      setPreviewSocialImage(data.secure_url);
      setFieldValue('socialImage', data.secure_url);
    } catch (e) {
      console.log('error', e);
    }
  };

  return (
    <CModal show={showModal} onClose={onModalClose}>
      <CForm className="p-sm-3 p-3" onSubmit={handleSubmit}>
        <CModalHeader closeButton>Add</CModalHeader>
        <CModalBody>
          <CRow>
            <CCol sm="12" md="12" className="xs-margin">
              <label className="text-swtich mr-2">Brand logo</label>
              <CInputFile
                type="file"
                ref={fileInput}
                values={values.logo}
                name="logo"
                accept="image/png, image/jpeg"
                onChange={handleLogoSelection}
              />
              {previewImage && (
                <div className="mt-2">
                  <img
                    className="img-thumbnail"
                    src={previewImage}
                    alt="brand"
                  />
                </div>
              )}
              {errors.logo && touched.logo && (
                <CFormText color="danger" className="help-block">
                  {errors.logo}
                </CFormText>
              )}
            </CCol>
          </CRow>
          <CRow className="mt-1">
            <CCol sm="12" md="12" className="xs-margin">
              <label className="text-swtich">Brand name</label>
              <CInput name="name" value={values.name} onChange={handleChange} />

              {errors.name && touched.name && (
                <CFormText color="danger" className="help-block">
                  {errors.name}
                </CFormText>
              )}
            </CCol>
          </CRow>
          <CRow className="mt-1">
            <CCol sm="12" md="12" className="xs-margin">
              <label className="text-swtich">Brand Buy Link</label>
              <CInput
                name="buyLink"
                value={values.buyLink}
                onChange={handleChange}
              />
              {errors.buyLink && touched.buyLink && (
                <CFormText color="danger" className="help-block">
                  {errors.buyLink}
                </CFormText>
              )}
            </CCol>
          </CRow>
          <CRow className="mt-1">
            <CCol sm="12" md="12" className="xs-margin">
              <label className="text-swtich">Brand Description</label>
              <CTextarea
                name="description"
                value={values.description}
                onChange={handleChange}
              ></CTextarea>
              {errors.description && touched.description && (
                <CFormText color="danger" className="help-block">
                  {errors.description}
                </CFormText>
              )}
            </CCol>
          </CRow>
          <CRow className="mt-1">
            <CCol sm="12" md="12" className="xs-margin">
              <label className="text-swtich">Brand categories</label>
              <CSelect
                name="categories"
                value={values.categories}
                multiple
                onChange={handleChange}
              >
                {categories &&
                  categories.map((category) => {
                    return (
                      <option value={category._id}>{category.name}</option>
                    );
                  })}
              </CSelect>
              {errors.categories && touched.categories && (
                <CFormText color="danger" className="help-block">
                  {errors.categories}
                </CFormText>
              )}
            </CCol>
          </CRow>
          <CRow className="mt-1">
            <CCol sm="12" md="12" className="xs-margin">
              <label className="text-swtich mr-2">Brand Social image</label>
              <CInputFile
                type="file"
                ref={fileInput}
                values={values.socialImage}
                name="logo"
                accept="image/png, image/jpeg"
                onChange={handleSocialImageSelection}
              />
              {previewSocialImage && (
                <div className="mt-2">
                  <img
                    className="img-thumbnail"
                    src={previewSocialImage}
                    alt="brand"
                  />
                </div>
              )}
              {errors.logo && touched.logo && (
                <CFormText color="danger" className="help-block">
                  {errors.logo}
                </CFormText>
              )}
            </CCol>
          </CRow>
          {isloading ? (
            <div className="text-center mt-2">
              <CSpinner color="info" />
            </div>
          ) : null}
        </CModalBody>
        <CModalFooter>
          <LoaderButton
            title={updateItem.name ? 'Update' : 'Add'}
            type="submit"
          />
          <CButton color="primary" onClick={onModalClose}>
            Cancel
          </CButton>
        </CModalFooter>
      </CForm>
    </CModal>
  );
};

export default BrandForm;
